import Menubar from '../MenuBarWebcast';
import Lazyload from 'react-lazy-load'
import HubspotForm from 'react-hubspot-form'
import ReadMoreContent from './ReadMoreContent';

const WebcastRegistration = (props) => {

    // const [link, setlink] = useState('')
    // const [showVideo, setshowVideo] = useState(false)

    // const [containerRef, isVisible] = useElementOnScreen({
    //     root: null,
    //     threshold: 0,
    //     rootMargin: "0px"
    // })

    // useEffect(() => {
    //     AOS.init({
    //         duration : 2000
    //       });
    // }, [])

    // useEffect(() => {
    //     console.log('visible');
    // }, [isVisible])

    const anjanText = `As the CTO and Co-Founder of the company, Anjan Pathak is responsible for the technological progress and evolution of <span style="font-weight: 600">Vantage Circle</span>. As a wellness and fitness enthusiast and an athlete holding the prestigious "Iron Man" title, he spearheaded the development of Vantage Fit to promote total employee well-being across organizations.`;
    const speaker1Text = `Himanshu Ajay Jain, the co-founder and wellbeing lead at <span style="font-weight: 600">MantraCare</span>, has over 13 years of experience working with multiple organizations to address issues of employee stress, burnout, and anxiety. He has spearheaded the end-to-end launch of employee assistance programs at more than 10 corporations. He has worked in more than eight countries to help Fortune 500 companies improve employee efficiency and motivation levels via structured interventions.`;


    return (
        <>
        <Menubar aboutWebcast = {'#aboutwebcast'} keyTakeaways = {'#keytakeaways'} speakers = {'#speakers'}/>
        <section className='col-12 py-5 hero-bg webcast webcast-hero'>
            <div className='container col-12'>
                <div className='col-lg-12'>
                    <div className='row align-items-center justify-content-center'>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 position-relative' style={{ padding: '0'}}>
                            <div className='webcast-label'>
                                <div>Celebrating Mental Health Awareness at Work</div>
                                {/* <div className=''></div> */}
                                <img className="position-relative img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/w_350/v1679479914/VantageFit/2023/vantagefit-webcast-negative_logo.png" />
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                            {/* <p style={{ color: '#fff', fontSize: '18px'}}>#WorldHealthDay</p> */}
                            <h1 className='sectionTitle-left font-weight-bold'>Mental Health at Work: Embracing a Positive View</h1>
                        </div>
                    </div>
                </div>
                <div className='col-12 d-flex'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 position-relative heroimg-webcast'>
                            <img loading = "lazy" className="img-responsive" src = "https://res.cloudinary.com/vantagecircle/image/upload/v1684992498/VantageFit/2023/vfit-webcast_2_hero.png"/>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                            <div className='guest'>Guests</div>
                            <div className='mb-4'>
                                <div className='mb-3'>
                                    <div className='text-red spkrname'>Himanshu Ajay Jain</div>
                                    <div className='spkr-d'>Co-founder and Wellbeing Lead, MantraCare</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='text-red spkrname'>Anjan Pathak</div>
                                    <div className='spkr-d'>CTO & Co-Founder, Vantage Circle</div>
                                </div>
                            </div>
                            <HubspotForm
                                portalId='6153052'
                                formId='e7468502-1efe-4460-aec6-d9a117f5d68c'
                                onSubmit={() => console.log('Submit!')}
                                onReady={(form) => console.log('Form ready!')}
                                loading={<div>Loading...</div>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className='col-12 formSection py-lg-6 bg-white'>
            <div className='container shadow date-details' style={{'width': '80%', borderRadius: '10px',}}>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-12 col-md-4 d-flex justify-content-center align-items-center'>
                            <img className="pr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1679315464/VantageFit/2023/Vantagefit-webcast-calender-icon.png" alt="Webinar date icon"/>
                            <div className="date"><strong>16th June, 2023</strong></div>
                        </div>
                        <div className='col-12 col-md-4 d-flex justify-content-center align-items-center'>
                            <img className="pr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1679315465/VantageFit/2023/vantagefit-webcast-time.png" alt="Webinar time icon"/>
                            <div className="date"><strong>3-4 PM IST</strong></div>
                        </div>
                        <div className='col-12 col-md-4 d-flex justify-content-center align-items-center'>
                            <img className="pr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/h_40/v1679315464/VantageFit/2023/vantagefit-webcast-location.png" alt="Webinar location icon"/>
                            <div className="date"><strong>Online</strong></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className='col-12 formSection bg-white'>
            <div className='container innerForm pt-3'>
                <h2 className='sectionTitle3 font-weight-bold col-12 mx-auto text-left'>Mental Health at Work: Embracing a Positive View</h2>
                <p className='sub-para col-12 mx-auto'>Mental Health is frequently misunderstood and overlooked despite its paramount importance to overall well-being. It is a topic that is under-discussed and overlooked in organizations worldwide. Optimal mental well-being makes employees happy and makes them more productive and efficient at work. In this episode, we will explore mental Health in-depth and discuss ways to celebrate Mental Health Month to maximize workplace productivity and employee well-being.</p>
            </div>
        </section>
        <section className='col-12' id="keytakeaways" name="keytakeaways">
            <div className='container py-lg-5 px-0' style={{ backgroundColor: 'rgb(250, 251, 255)' }}>
                <div className='row col-12 d-flex justify-content-around' style= {{ padding: '0 60px'}}>
                    <div className='mt-4 pb-0 py-lg-5 py-xl-0 pt-xl-4 mt-xl-0 col-12 col-xl-6 walkathon-form h-full'>
                        <h2 className='sectionTitle3 font-weight-bold mx-auto text-left'>Key Takeaways</h2>
                        <ul className="mainbullets sub-para"><li> Learn all about mental health and its importance in the workplace.</li><li>Identify mental health issues and triggers and learn how to address them properly</li><li>Develop an action plan to prioritize employee mental health to enhance workplace culture.</li></ul>
                    </div>
                    <div className='col-12 col-xl-6 mx-auto pr-xl-1 pt-xl-5 mt-xl-5'>
                        <div className='d-flex justify-content-center align-items-center'>

                            <img src='https://res.cloudinary.com/vantagecircle/image/upload/v1631098362/gatsbycms/uploads/2022/03/Key-takeaways-img.png' loading='lazy' style= {{ borderRadius: '10px'}} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='col-12 formSection pt-0 pb-5 py-lg-5 bg-white' id="aboutwebcast" name="aboutwebcast">
            <div className='container innerForm'>
                <h2 className='sectionTitle3 font-weight-bold col-12 mx-auto'>About <span className='text-red'>Vantage Fit Webcast</span></h2>
                <p className='sub-para col-12 mx-auto text-center'>The Vantage Fit Webcast aims to provide strategies and information from top corporate wellness leaders and experts. From day-to-day workplace wellness issues to wellbeing events on a global scale, it aims to address and discuss multiple aspects of employee wellbeing topics to facilitate healthier and happier workplaces.</p>
            </div>
        </section>
        <section className='col-12' style={{ backgroundColor: 'rgb(250, 251, 255)', padding:'0px 60px!important' }}>
            <div className='container py-lg-5 px-0 position-relative' >
                <div className='position-absolute'  style= {{ top: '-35px', left:'35px'}}><img src='https://res.cloudinary.com/vantagecircle/image/upload/w_120/v1679315465/VantageFit/2023/vantagefit-webcast-quotes.png'/></div>
                <div className='row col-12 justify-content-around'>
                    <div className='pb-0 py-lg-5 py-xl-0 pt-xl-5 col-12 col-lg-6 col-xl-6 walkathon-form h-full'>
                        <h3>Message from our CTO</h3>
                        <p className='sub-para mt-4' style= {{ marginTop: '10px'}}><em>I am excited to announce the inception of the <span style={{'fontWeight': '600'}}>Vantage Fit Webcast</span>, the latest offering from Vantage Circle. With it, I envision various employee well-being and corporate wellness problems being discussed and tackled from multiple perspectives of global thought leaders to develop innovative and effective wellness solutions. So if you are interested in understanding how wellness at work "works," then register now to get a birds-eye view of all the latest and greatest insights from corporate wellness experts and help create workplaces healthier and the world more sustainable. </em></p>
                    </div>
                    <div className='col-12 col-lg-6 col-xl-6 mx-auto pr-xl-1 pt-xl-5'>
                        <div className='text-center border-l-gray'>
                            <img src='https://res.cloudinary.com/vantagecircle/image/upload/w_300/v1679479914/VantageFit/2023/Anjan_Pathak.png' loading='lazy' />
                            <h3 className="mt-5">Anjan Pathak</h3>
                            <p className='sub-para text-center mt-0'>CTO & Co-founder, Vantage Circle</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="speakers" name="speakers" className='d-flex flex-column justify-content-center align-items-center  py-5 bg-light-yellow'>
            <div className='container'>
                <h2 className='col-12 sectionTitle-center font-weight-bold text-center pt-5'>Guest Speakers</h2>
                <div className='col-8 my-3 mt-lg-5 mx-auto'>
                    <div className='row'>
                        <div className='col-12 col-md-6 my-lg-0 my-4 py-4 px-lg-5'>
                            <div className='text-center'>
                                <img src='https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1685091765/VantageFit/2023/Himanshu.png' loading='lazy' alt="Ankit Malhotra"/>
                                <h3 className="mt-5">Himanshu Ajay Jain</h3>
                                <p className='sub-para text-center mt-0 f-400'>Co-founder & Wellbeing Lead<br/>MantraCare</p>
                            </div>
                            <ReadMoreContent text={speaker1Text} maxLength={212} />
                        </div>
                        <div className='col-12 col-md-6 my-lg-0 my-4 py-4 px-lg-5'>
                            <div className='text-center'>
                                <img src='https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1685091929/VantageFit/2023/Anjan.png' loading='lazy' alt="Anjan Pathak"/>
                                <h3 className="mt-5">Anjan Pathak</h3>
                                <p className='sub-para text-center mt-0 f-400'>CTO & Co-founder<br/>Vantage Circle</p>
                            </div>
                            <ReadMoreContent text={anjanText} maxLength={208} />
                        </div>
                        {/* <div className='col-12 col-lg-4 my-lg-0 my-4 py-4 px-lg-5'>
                            <div className='text-center'>
                                <img src='https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1679551508/VantageFit/2023/Alpa_Momaya.png' loading='lazy' alt="Alpa Momaya"/>
                                <h3 className="mt-5">Alpa Momaya</h3>
                                <p className='sub-para text-center mt-0 f-400'>R&D Head, Nutrition<br/>Healthifyme</p>
                                <p className='sub-para-1'>Specializing in Clinical Nutrition, Pre & Post Natal Diets, and Weight Management, Alpa Momaya works as R&D Head, Nutrition with <span style={{'fontWeight': '600'}}>Healthifyme</span>. Alpa has a great love for healthy cooking and is a Registered Nutritional Practitioner (Canada) with over 20 years of experience in the field.</p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default WebcastRegistration;



